import axios from '../utils/ajax'
// 获取二维码
export const queryQrCode = params => axios.get('/managementPlatform/electricity/queryQrCode',{params})



// WEBPACK FOOTER //
// ./src/api/common.js